import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthCenteredLayout from '@layouts/AuthCenteredLayout/AuthCenteredLayout';
import Button from '@components/Button/Button';
import Icon from '@components/common/Icon';

const CheckInboxPage = () => {
    const { t } = useTranslation('auth');
    const navigate = useNavigate();
    const location = useLocation();
    const email = (location.state as { email?: string })?.email ?? 'your email';
    const steps = [t('check_inbox.step1'), t('check_inbox.step2'), t('check_inbox.step3')];

    return (
        <AuthCenteredLayout>
            <div className="bg-white rounded-xl shadow-[var(--shadow-lg)] border border-[var(--neutral-color)] p-[20px] 2xl:p-[30px] flex flex-col items-center">
                <div className="w-10 h-10 2xl:w-14 2xl:h-14 rounded-lg bg-[var(--primary-surface-color)] flex items-center justify-center mb-[20px] 2xl:mb-[30px]">
                    <Icon name="checkCircle" className="w-auto h-[18px] 2xl:h-[26px]" />
                </div>
                <div className="text-center">
                    <h1 className="text-[18px] 2xl:text-[24px]  font-semibold text-[var(--secondary-color)]">{t('check_inbox.title')}</h1>
                    <p className="text-[12px] 2xl:text-[14px] text-[var(--disabled-text-color)]">{t('check_inbox.subtitle')}</p>
                    <p className="text-[13px] 2xl:text-[16px] font-medium text-[var(--secondary-color)] ">{email}</p>
                </div>
                <div className="w-full flex flex-col bg-[var(--primary-canvas-color)] border border-[var(--neutral-color)] p-4 2xl:p-5 rounded-lg my-[20px] 2xl:my-[30px]">
                    {steps.map((step, i) => (
                        <div key={i} className="flex items-center gap-2 mb-[10px] last:mb-0">
                            <span className="min-w-[16px] 2xl:min-w-[20px] h-[16px] 2xl:h-[20px] rounded-full bg-[var(--primary-color)] text-white text-[10px] 2xl:text-[12px] font-semibold flex items-center justify-center shrink-0 leading-tight">
                                {i + 1}
                            </span>
                            <p className="text-[12px] 2xl:text-[13px] text-[var(--secondary-color)] leading-tight">{step}</p>
                        </div>
                    ))}
                </div>
                <p className="text-[12px] 2xl:text-[14px] font-medium text-[var(--primary-color)]">
                    {t('check_inbox.resend')}{' '}
                    <Button variant="link" onClick={() => { /* TODO: resend */ }}>
                        {t('check_inbox.resend_link')}
                    </Button>
                </p>
            </div>
            <div className="flex justify-center mt-5">
                <Button variant="ghost" onClick={() => navigate('/admin/signin')}>
                    <Icon name="arrowLeft" size={14} className="mr-2" />
                    {t('check_inbox.back_to_sign_in')}
                </Button>
            </div>
        </AuthCenteredLayout>
    );
}

export default CheckInboxPage;
